import { render, staticRenderFns } from "./ShipbluSelect.vue?vue&type=template&id=502fa2b8&scoped=true"
import script from "./ShipbluSelect.vue?vue&type=script&lang=js"
export * from "./ShipbluSelect.vue?vue&type=script&lang=js"
import style0 from "./ShipbluSelect.vue?vue&type=style&index=0&id=502fa2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fa2b8",
  null
  
)

export default component.exports